<template>
  <div class="kye-header noselect">
    <div class="panel panel_l" :style="panelLogoStyle" @click.stop="openOperationInterface">
      <div class="logo-wrap">
        <span class="logo"></span>
        <span class="operation-interface-mark__dot" v-if="showOperationInterfaceMark"></span>
      </div>
      <!-- <div class="operation-interface-mark"></div> -->
      <h2 class="system-name" ref="systemName" v-if="!isCollapse && !isSystemName"  :title="systemNameTitle" @mouseenter="handleMouseEnter">{{title}}</h2>
      <span class="system-name-img" v-if="!isCollapse && isSystemName"></span>
      <span v-if="showGrayFlag" class="system-name-gray"  :class="{'is-collapse': isCollapse}">灰度</span>
    </div>
    <div class="panel panel_r" :class="{ 'panel_r_end': !user || !user.name }" :style="panelRstyle">
      <!-- <HeaderSearch v-if="user.name" /> -->
      <div></div>
      <div class="panel_r_right">
        <div class="vms-vehicle-count-box tool-wrap">
          <vms-vehicle-count class="vms-vehicle-count" />
        </div>

        <MultiModulePanel :multiVersionName="multiVersionName" :multiInfoId="multiInfoId" />
        <AuthApply class="auth-apply-wrap tool-wrap"></AuthApply>
        <div class="header-tools-wrap tool-wrap">
          <!-- 工具 -->
          <div class="header-tools-item">
            <div class="tools-btn" v-popover:toolsPopover>
              <i class="layout layout-tools1"></i>
              <span>工具</span>
            </div>

            <el-popover
              ref="toolsPopover"
              placement="bottom"
              trigger="hover"
              :open-delay="400"
              v-show="lookUpOptionsLoaded"
              popper-class="header-tool-popover"
              width="292">
              <ul class="header-tool-wrap">
                <li v-for="opt in tools"
                    :key="opt.title"
                    class="item"
                    @click="showHelper(opt)">
                  <i :class="`layout layout-${opt.icon}`"></i>
                  <p>{{opt.title}}</p>
                </li>
              </ul>
            </el-popover>
          </div>
          <!-- <div class="header-tools-wrap-line" v-show="lookUpOptionsLoaded"></div> -->

          <!-- 工单 -->
          <div class="header-tools-item kts-gd-plugin-tool" @click="openKtsPlugin">
            <div id="kts-gd-plugin-wrapper" style="padding:0;"></div>

            <i class="layout layout-work-order"></i>
            <span>工单</span>
            <span class="kts-gd-plugin-tool_dot" :style="gdDotStyle" v-show="showGdDot && gdCount">{{gdCount}}</span>
          </div>

          <!-- 咨询解答 -->
          <template v-if="user.name">
            <!-- <div class="header-tools-wrap-line"></div> -->
            <CrmwasAnswer class="header-tools-item crm-was-answer"/>
          </template>
        </div>
        <DropdownMenu />
      </div>
    </div>
    <kye-dialog class="kye-header-tools-helper-dialog"
                :title="toolsDailogOptions.title"
                :width="toolsDailogOptions.width"
                :modal="toolsDailogOptions.modal"
                :visible.sync="toolsDailogOptions.visible"
                append-to-body
                :view.sync="toolsDailogOptions.view"
                :before-close="closeToolsHelper">
      <component :is="toolsDailogOptions.view"
                 @close="closeToolsHelper"
                 :helper="toolsDailogOptions.helper"
                 :url="toolsDailogOptions.url"
                 :upgradeLogList="upgradeLogList">
      </component>
    </kye-dialog>
    <kye-dialog :title="dialogOptions.title"
                :width="dialogOptions.width"
                :visible.sync="dialogOptions.visible"
                append-to-body
                :view.sync="dialogOptions.view"
                :before-close="closeHelper">
      <component :is="dialogOptions.view"
                 @close="closeHelper"
                 :helper="dialogOptions.helper"
                 :url="dialogOptions.url"
                 :upgradeLogList="upgradeLogList">
      </component>
    </kye-dialog>
    <module-upgrade-log />
    <safe-tips />
    <Scheduling />
    <QuestionnaireTips />
    <operation-interface ref="operationInterface" @showTips="handleShowOperationInterfaceMark"/>
  </div>
</template>

<script>
  // import { createWatermarkStyle } from 'public/utils'
  import { TITLE } from './conf'
  import { tools } from '@/shared/home-modules/helpers/form'
  import VmsVehicleCount from '@/shared/home-modules/header/vms-vehicle-count'
  import CommentWrapper from '../components/comment'
  import ModuleUpgradeLog from '../components/module-upgrade-log'
  import SafeTips from '../components/safe-tips'
  import Scheduling from '../components/scheduling'
  import OperationInterface from '../components/operation-interface'
  // import HrVideoTutorial from '../components/hr-video-tutorial'
  import MultiModulePanel from '../components/multi-module-panel.vue'
  import { ENV } from 'public/config'
  import { getMultiModuleData } from '@/layout/utils'
  import { getSubModuleName, getMatchedModule } from '@/layout/router/remote/index.js'
  // import HeaderSearch from '../components/header-search.vue'
  import DropdownMenu from '../components/dropdown-menu.vue'
  export default {
    name: 'header-top',
    components: {
      MultiModulePanel,
      Helper: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/index'),
      GPSLocation: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/GPSLocation'),
      CarSwingCard: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/car-swing-card'),
      Calendar: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/calendar'),
      Log: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/log'),
      Sms: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/sms'),
      Distance: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/distance'),
      // Comment: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/comment'),
      MapAuth: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/mapAuth'),
      VirtualNumber: () => import(/* webpackChunkName: "public-helpers" */ '@/shared/home-modules/helpers/virtual-number'),
      OperationInterface,
      VmsVehicleCount,
      CommentWrapper,
      ModuleUpgradeLog,
      SafeTips,
      QuestionnaireTips: window.__ERP_REMOTE_IMPORT__('qms/QmsQuestionnaireGlobalModal'),
      Scheduling,
      CrmwasAnswer: window.__ERP_REMOTE_IMPORT__('crm_was/crmwasAnswer'), // 咨询解答
      AuthApply: window.__ERP_REMOTE_IMPORT__('sys/HomeAuthApply'), // 权限申请
      // HeaderSearch,
      DropdownMenu,
      // HrVideoTutorial
    },
    data () {
      return {
        isProd: ENV === 'prd',
        search: '',
        tools: tools.filter(v => v.helper !== 'addressSearch'),
        dialogOptions: this.genDialogOptions(),
        toolsDailogOptions: this.genDialogOptions(),
        showGdDot: false,
        gdDotColor: '#FF8600',
        upgradeLogList: [],
        // svgFilter: +localStorage.svgFilter || 1,
        title: this.getSystemName(),
        gdCount: 0, // 工单未读数
        multiVersionName: '', // 泳道环境-版本名称
        multiInfoId: '', // 泳道环境-版本id
        systemNameTitle: '', // 系统名称-标题
        isCollapse: false,
        menuWidth: 160,
        showOperationInterfaceMark: false, // 使用测试环境的通用查询|数据字典标识红点展示
        showGrayFlag: false, // 灰度标识
      }
    },
    created () {
      this.$bus.$on('SET_THEME', this.themeChange)
      this.$bus.$on('KTS_RED_DOT', this.ktsPluginDotChange)
      this.$bus.$on('SET_SYSTEM_NAME', this.setSystemName)
      this.$bus.$on('SWITCH_MENU', this.collapseMenu)
      // this.$bus.$on('HELPER_COMMET', this.showComment)
      // this.$bus.$on('HELPER_VIDEO', this.showVideo)
    },
    mounted () {
      this.clickNum = 0
      // this.$bus.$once('APP_LOADED', this.onAppLoaded)
      // this.svgFilterChange(this.svgFilter)
    },
    beforeDestroy () {
      this.$bus.$off('SET_THEME', this.themeChange)
      this.$bus.$off('KTS_RED_DOT', this.ktsPluginDotChange)
      this.$bus.$off('SET_SYSTEM_NAME', this.setSystemName)
      this.$bus.$off('SET_GARY', this.grayChange)
      this.$bus.$off('SWITCH_MENU', this.collapseMenu)
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      avatar () {
        return this.$store.state.avatar
      },
      gdDotStyle () {
        return { backgroundColor: this.gdDotColor }
      },
      lookUpOptionsLoaded () {
        return Object.keys(this.$store.state.lookUpOptions).length
      },
      panelLogoStyle() {
        if (this.isCollapse) {
          return {
            width: this.menuWidth + 'px',
            justifyContent: 'center',
            marginLeft: 0
          }
        }
        return null
      },
      panelRstyle() {
        if (this.isCollapse) {
          return {
            width: `calc(100% - ${this.menuWidth}px)`
          }
        }
        return null
      },
      isSystemName () {
        return this.title === TITLE
      }
    },
    methods: {
      themeChange (obj, type) {
        if (!this.rootEl) {
          this.rootEl = this.$el
        }
        if (!this.avatarEl) {
          this.avatarEl = this.rootEl.querySelector('.user-avatar i')
        }
        if (!type || type === 'header') {
          if (!this.avatar) {
            this.avatarEl.style.color = obj.headerGradient
          }
          this.rootEl.style.background = `linear-gradient(90deg, ${obj.header}, ${obj.headerGradient})`
        }
      },
      // 获取系统名称
      getSystemName() {
        let title = TITLE
        if (ENV && ENV !== 'prd') {
          title = `${ENV.toUpperCase()}-${title}`
        }
        const name = localStorage.GLOABL_ERP_SYSTEM_NAME
        return name || title + (window.location.pathname === '/' ? '' : ` - ${window.location.pathname.slice(1, -1)}`)
      },
      // 修改系统名称
      setSystemName () {
        let title = this.getSystemName()
        this.showGrayFlag = this.isGrayModulebyRoute()
        this.title = title
        // 灰度没有泳道
        if (this.showGrayFlag) return
        this.setMultiName()
      },
      // 设置多版本文案
      setMultiName () {
        const name = this.getMultiModuleByRoute()
        if (name) {
          this.multiVersionName = name
        }
      },
      collapseMenu(menuWidth, isCollapse) {
        this.menuWidth = menuWidth
        this.isCollapse = isCollapse
      },
      // 2022-12-21 判断当前菜单模块是否是灰度模块
      isGrayModulebyRoute () {
        const moduleName = getSubModuleName(this.$route)
        const moduleMeta = getMatchedModule(moduleName)
        let grayModules = sessionStorage.ERPGRAYMODULE
        grayModules = grayModules ? grayModules.split(',') : []
        return moduleMeta ? grayModules.includes(moduleMeta.name) : false
      },
      // 2023-02-11 判断非生产环境是否是多版本
      getMultiModuleByRoute () {
        try {
          // if (this.isProd) {
          //   return ''
          // }
          const multiSessionData = getMultiModuleData()
          if (multiSessionData) {
            this.multiInfoId = multiSessionData.envId
            return `(${multiSessionData.systemName}/${multiSessionData.envName})`
          }
          return ''
        } catch (err) {
          console.error('getMultiModuleByRoute:', err)
          return ''
        }
      },
      handleMouseEnter() {
        const el = this.$refs.systemName
        this.systemNameTitle = ''
        if (el && (el.scrollWidth > el.clientWidth)) {
          this.systemNameTitle = this.title
        }
      },
      // 通用弹窗
      showDynamicDialog(view, title, width = '1200px') {
        this.dialogOptions.visible = true
        this.dialogOptions.view = view
        this.dialogOptions.title = title
        this.dialogOptions.width = width
      },
      genDialogOptions () {
        return { title: '', visible: false, view: '', width: null, helper: '', url: '', modal: true }
      },
      showHelper (opt) {
        if (opt.func) {
          return opt.func(this)
        }
        if (this.toolsDailogOptions.visible) {
          this.closeToolsHelper()
        }
        this.$nextTick(() => {
          this.toolsDailogOptions.title = opt.title
          this.toolsDailogOptions.width = opt.width || 6
          this.toolsDailogOptions.helper = opt.helper
          this.toolsDailogOptions.url = opt.url
          this.toolsDailogOptions.view = opt.view || 'Helper'
          this.toolsDailogOptions.modal = false
          this.toolsDailogOptions.visible = true
        })
      },
      closeHelper () {
        this.dialogOptions = this.genDialogOptions()
      },
      closeToolsHelper () {
        this.toolsDailogOptions = this.genDialogOptions()
      },
      // showComment () {
        // this.showHelper({
        //   title: '使用评价',
        //   width: 3.5,
        //   helper: null,
        //   url: null,
        //   view: 'Comment',
        // })
      // },
      openKtsPlugin (e) {
        if (this.ktsGdPlugin) {
          this.ktsGdPlugin.open()
          return
        }
        // 判断是否正在初始化，避免重复点击
        if (this.isKtsInitializing) {
          return
        }
        this.isKtsInitializing = true
        let ktsModule = null
        const ktsEntry = 'kts'
        if (!ENV) {
          ktsModule = import(/* webpackChunkName: "kts-gd-plugin" */ `@/${ktsEntry}/components/kts-work-plugin/index.vue`)
        } else {
          ktsModule = new Promise(window.__ERP_REMOTE_IMPORT__('kts/ktsGdPlugin'))
        }
        ktsModule.then(res => {
            let Ctor = this.$options._base.extend(res.default)
            this.ktsGdPlugin = new Ctor({ parent: this })
            this.ktsGdPlugin.$mount('#kts-gd-plugin-wrapper')
            if (e && e.clientX && e.clientY) {
              this.ktsGdPlugin.$nextTick(_ => {
                this.ktsGdPlugin.open()
                this.isKtsInitializing = false
              })
            }
          })
          .catch(console.log)
      },
      ktsPluginDotChange (data) {
        this.showGdDot = data && data.isShow
        this.gdDotColor = (data && data.color) || '#FF8600'
        this.gdCount = data && data.count
      },
      openOperationInterface () {
        this.$router.push('/')
        this.clickNum += 1
        if (this.clickNum >= 5) {
          this.clickNum = 0
          this.$refs.operationInterface.show = true
        }
      },
      handleShowOperationInterfaceMark (val) {
        console.log('val-----', val)
        this.showOperationInterfaceMark = val
      }
      // showVideo () {
      //   this.showHelper({
      //     title: '视频教程',
      //     width: 4.2,
      //     helper: null,
      //     url: null,
      //     view: 'HrVideoTutorial',
      //   })
      // },
    }
  }
</script>

<style lang="scss">
  .kye-header {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background-color: var(--g-theme-header-bg-color);
    // background-image: var(--g-theme-header-bg-image, none), var(--g-theme-header-gradient-bg);
    // background-size: auto 78px, 100% 100%;
    // background-repeat: no-repeat, no-repeat;
    // background-position: top right, 0 0;
    .el-input {
      .el-input__inner {
        border-radius: 20px;
        background-color: transparent;
        border-color: #aaa;
        color: #ffffff;
      }
    }

    .panel {
      display: flex;
      align-items: center;
      width: 160px;
      // padding-left: 12px;
      &.panel_l {
        // padding-top: 30px;
        margin-top: 30px;
        margin-left: 12px;
        cursor: pointer;
        position: relative;
      }
      .logo-wrap {
        margin-right: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .logo {
          display: block;
          width: 40px;
          height: 40px;
          mask-image: url('./images/logo.svg');
          background-color: var(--g-theme-logo-color);
        }
      }
      // i.layout {
      //   width: 18px;
      //   &.layout-kuasheng1 {
      //     font-size: 18px;
      //   }
      // }
      // i.logo {
      //   color: rgba(121, 83, 246, 1);
      //   width: 18px;
      //   height: 20px;
      //   font-size: 24px;
      // }
      svg {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      a:hover svg rect {
        stroke-width: 2px;
      }
      .check-rule-tool {
        display: flex;
        align-items: center;
        cursor: pointer;
        .layout-check-rule-icon {
          width: 18px;
          font-size: 17px;
        }
      }
      .system-name {
        font-size: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--g-theme-logo-color);
      }
      .system-name-img {
        width: 48px;
        height: 24px;
        mask-image: url('./images/system-name.svg');
        background-color: var(--g-theme-logo-color);
      }
      .system-name-gray {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 2px 6px;
        margin-left: 5px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: var(--g-theme-logo-gray-color);
        background: rgba(255, 255, 255, 0.2);
        &.is-collapse {
          position: absolute;
          top: 0;
          right: -32px;
        }
      }
      .operation-interface-mark__dot {
        position: absolute;
        right: -3px;
        top: -2px;
        width: 6px;
        height: 6px;
        background-color: #ff586c;
        border-radius: 6px;
        display: inline-block;
      }
      // .operation-interface-mark {
      //   position: relative;
      //   height: 30px;
      // }
    }
    @mixin toolhover {
      color: var(--g-theme-header-action-color-text-hover);
      background-color: var(--g-theme-header-action-bg-hover);
    }
    .panel_r {
      height: 100%;
      display: flex;
      width: calc(100% - 160px);
      padding-right: 12px;
      padding-left: 0;
      min-width: 0;
      align-items: center;
      justify-content: space-between;
      .panel_r_right {
        display: flex;
        align-items: center;
      }
      .vms-vehicle-count-box {
        .vms-vehicle-count {
          height: 28px;
          padding: 6px 12px;
          border-radius: 16px;
          &:hover {
            @include toolhover;
          }
        }
      }

      .tool-wrap {
        margin-right: 12px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: var(--g-theme-header-action-color-text);
        background: var(--g-theme-header-action-bg);
        .layout {
          font-size: 13px;
          width: auto;
          margin-right: 4px;
          &.layout-a-quanxianshenqing1x:before {
            content: '\e751';
          }
          &.layout-guidance:before {
            content: '\e750';
          }
        }

        // 权限申请
        &.auth-apply-wrap{
          display: block;
          min-width: 89px;
          height: 28px;
          padding: 6px 12px;
          border-radius: 16px;
          &:hover {
            @include toolhover;
          }
          .flex-tool {
            padding: 0;
          }
          /deep/ .flex-tool .layout{
            width: 13px;
            height: 16px;
            margin-right: 3px;
          }
        }
      }

      .header-tools-wrap {
        display: flex;
        align-items: center;
        padding: 2px;
        padding-top: 1px;
        height: 28px;
        div.header-tools-item {
          position: relative;
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 0 12px;
          height: 24px;
          &::after {
            position: absolute;
            content: '';
            top: 0;
            right: 0;
            width: 1px;
            height: 8px;
            margin-top: 4px;
            transform: translateY(50%);
            background: var(--g-theme-divider);
          }
          &:last-child {
            &::after {
              display: none;
            }
          }
          &:hover {
            @include toolhover;
            border-radius: 2px;
            &:first-child {
              border-top-left-radius: 12px;
              border-bottom-left-radius: 12px;
            }
            &:last-child {
              border-top-right-radius: 12px;
              border-bottom-right-radius: 12px;
            }
          }
        }
        // &-line {
        //   width: 1px;
        //   height: 9px;
        //   background: var(--g-theme-divider);
        // }

        // 咨询解答
        .crm-was-answer {
          height: auto;
          min-width: 90px;
          // &:hover {
          //   @include toolhover;
          //   border-radius: 2px 12px 12px 2px;
          // }
          .layout-guidance {
            margin-top: 1px;
          }
          .crmwas-answer-plugin-tool {
            padding: 0;
          }
        }

        // .header-tools-wrap-line:has(+ .crm-was-answer[style*="display: none"]) {
        //   display: none;
        // }
      }
    }
    .panel_r_end {
      justify-content: flex-end;
    }
    .panel_r_right > span .layout {
      height: 15px;
    }
    .flex-tool {
      display: flex;
      align-items: center;
      padding: 4px 12px;
      cursor: pointer;
    }
    .header-tool {
      min-width: 66px;
      &:hover {
        @include toolhover;
        // border-radius: 12px 2px 2px 12px;
      }
    }
    .kts-gd-plugin-tool {
      position: relative;
      // min-width: 66px;
      // &:hover {
      //   @include toolhover;
      //   border-radius: 2px;
      // }
      &_dot {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -14px;
        right: -2px;
        transform: translateX(50%);
        height: 16px;
        line-height: 16px;
        padding: 2px 4px 2px 4px;
        text-align: center;
        color: #ffffff;
        background-color: #ff5351;
        border-radius: 8px;
        font-size: 12px;
      }
    }
  }
  .kye-header-tools-helper-dialog {
    pointer-events: none;
    > .el-dialog {
      pointer-events: auto;
    }
  }
  .kye-header-multi-popover {
    text-align: left;
    padding: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/layout/layout/header.vue